<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'lanseedForm',
})
</script>
<template>
  <a-modal v-if="mode==false"  v-model:open="opend" :centered="true" :bodyStyle="{overflowY:'auto',height:'80vh'}" :destroyOnClose="true"  @cancel="Cancel" width="80%"  @ok="submit">
    <template #title>
      <div class="flex align-center text-lg text-bolder">
        <CopyTwoTone twoToneColor="#13c2c2" style="font-size: 28px;"  class="margin-right-sm text-bolder"  /> {{title}}</div>
    </template>
         <lanseed-form-only ref="form" :data="data" :rules="rules" :mode="mode"  :btn="false" @change="change" >
          <template #ext>
             <slot></slot>
          </template>
         </lanseed-form-only>
    </a-modal>
    <a-drawer  v-else
    width="40%"
    v-model:open="opend"
    class="custom-class"
    root-class-name="root-class-name"
    placement="right"
    :destroyOnClose="true"
    @close="Cancel"
    :footerStyle="{textAlign:'center',padding:'10px'}"
  >
   <template #title>
      <div class="flex align-center text-lg text-bolder">
        <CopyTwoTone twoToneColor="#13c2c2" style="font-size: 28px;"  class="margin-right-sm text-bolder"  /> {{title}}</div>
    </template>
    <template #footer>
          <a-button type="primary" size="large" @click="submit">确定</a-button>
    </template>
         <lanseed-form-only ref="form" :data="data" :rules="rules" :mode="mode" @change="change" :btn="false" style="min-height: 80vh;">
          <template v-for="(item,i) in slots" :key="i" v-slot:[item]>
              <slot :name="item"></slot>
          </template>
          <template #ext>
            <slot></slot>
          </template>
         </lanseed-form-only>

  </a-drawer>
</template>
<script setup lang="ts" name="lanseedForm">

import {ref,defineExpose,defineProps,defineEmits,watch,onMounted } from 'vue'
import lanseedFormOnly from './formonly.vue'
import {FormOutlined,CopyTwoTone} from '@ant-design/icons-vue'

const emit = defineEmits(['change','update:open'])

const opend=ref<boolean>(false)
const change=(e):void=>{
  emit('change',e)
}
const slots=ref<Array>([])
onMounted(()=>{
  if(props.rules){
    for(var k in props.rules){
      var it=props.rules[k].domtype
      if(it=='slot'){
        slots.value.push(k)
      }
    }
  }
})

const props = defineProps({
  data: {
    type: Object
  },
  rules:{
    type:Object
  },
  mode:{
    type:Boolean,default:true //true:表单，false搜索
  },
  title:{
    type:String,default:'编辑'
  },
  open:{
    type:Boolean,default:false
  }
})
const form=ref()
const submit=():void=>{
  form.value.submit()
}
const Cancel=(e):void=>{
  emit('update:open',opend.value)
}
watch(()=>props.open,(n,o)=>{
  opend.value=n
},
//{immediate: true, deep: true}
)
</script>
